import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'
import { Redirect, withRouter } from 'react-router'

import AccessibleForm from '../../../../components/accessibility/AccessibleForm/AccessibleForm'
import Layout from '../../../../components/ui/Layout/Layout'

import validateOtp from '../../../../services/validation/OTP'
import OtpForm from '../../../../components/home/OtpForm/OtpForm'
import OtpResendForm from '../../../../components/home/OtpResendForm/OtpResendForm'

import { OTP } from '../../../../services/data/accountRecoverySteps.json'

import { setGAPageView } from '../../../../services/analytics/google-analytics'
import media from '../../../../services/generateMediaQueries'

const Title = styled.h1`
  font-size: 1.5rem;
  text-align: center;
  margin-top: 0;
  font-weight: var(--font-weight-boldest);
  color: var(--color-secondary);
`

const Description = styled.p`
  text-align: center;
`

const FormWrapper = styled.div`
  margin: 2.5rem 0;
  margin-bottom: ${({ noMarginBottom }) => (noMarginBottom ? 0 : '2.5rem')};
  ${media.lessThan('small')`
    margin: 1.5rem 0;
    margin-bottom: ${({ noMarginBottom }) => (noMarginBottom ? 0 : '1.5rem')};
  `};
`

const PermissionLabel = styled.div`
  text-align: center;
  font-size: 0.875rem;
  margin: 1rem 0;
`

const MainView = props => {
  const {
    recoveryStep,
    setProfileModalPage,
    displayProfileModal,
    recoveryRequestId,
    setRecoveryRequestId,
    setPrimaryInfo,
    recoveryMaskedData,
    setRecoveryStep,
    replace,
    doVerifyOtp,
    setAccessToken,
    doResendOtpRecoveryRequest,
    location,
  } = props

  React.useState(() => {
    setGAPageView(location.pathname)
  }, [])

  const { email, maskedEmail } = recoveryMaskedData || {}

  if (recoveryStep !== OTP) {
    return <Redirect to="/account-recovery" />
  }

  return (
    <Layout>
      <Title>Verify mobile number</Title>
      <Description>
        You will receive a One-Time PIN (OTP) on your registered email address{' '}
        <span>{maskedEmail}</span>
      </Description>
      <FormWrapper>
        <AccessibleForm
          initialValues={{}}
          validate={validateOtp}
          onSubmit={doVerifyOtp({
            setRecoveryRequestId,
            recoveryRequestId,
            setPrimaryInfo,
            setRecoveryStep,
            replace,
            setProfileModalPage,
            displayProfileModal,
            setAccessToken,
            searchString: location.search,
          })}
          component={OtpForm}
          action="/a/otp/submit"
          method="post"
        />
      </FormWrapper>
      <PermissionLabel>
        <AccessibleForm
          initialValues={{}}
          onSubmit={doResendOtpRecoveryRequest({ setRecoveryRequestId, email })}
          component={OtpResendForm}
          action="/a/otp/resend"
          method="post"
        />
      </PermissionLabel>
    </Layout>
  )
}

MainView.defaultProps = {
  primaryInfo: null,
  step: OTP,
  push: null,
}

MainView.propTypes = {
  primaryInfo: PropTypes.shape(),
  step: PropTypes.number,
  push: PropTypes.func,
}

export default withRouter(MainView)
